/* eslint-disable @typescript-eslint/naming-convention */

import { AdminZone2 } from '@app/interfaces/admin-zone-2'
import type { ArchivesPlacesPlaceList } from '@app/generated/api/model'

export interface Place {
  id?: number
  code: string
  name: string
  admin_zone_2?: AdminZone2 | null
}

export function newPlace (): Place {
  return {
    code: '',
    name: '',
  }
}

export function toPlaceForm (place: ArchivesPlacesPlaceList): Place {
  return {
    id: place.id,
    code: place.code ?? '',
    name: place.name,
    admin_zone_2: place.admin_zone_2 ? {
      id: place.admin_zone_2.id,
      adm1_src: '',
      adm2_id: '',
      adm2_src: '',
      adm2_name: place.admin_zone_2.adm2_name,
      admin_zone_1: place.admin_zone_2.admin_zone_1 ? {
        adm0_src: '',
        adm1_id: '',
        adm1_src: '',
        adm1_name: place.admin_zone_2.admin_zone_1.adm1_name,
        country: place.admin_zone_2.admin_zone_1.country ? {
          id: place.admin_zone_2.admin_zone_1.country.id,
          code_iso: place.admin_zone_2.admin_zone_1.country.code_iso,
          code_iso_2: null,
          label_en: place.admin_zone_2.admin_zone_1.country.label_en,
          label_fr: place.admin_zone_2.admin_zone_1.country.label_fr,
        } : null,
      } : null,
    } : null,
  }
}
